"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCustomer = void 0;
var _useQuestionsMetadata = require("./useQuestionsMetadata");
const useCustomer = () => {
  var _metadata$flags;
  const metadata = (0, _useQuestionsMetadata.useQuestionsMetadata)({});
  const isCustomer = metadata === null || metadata === void 0 ? void 0 : (_metadata$flags = metadata.flags) === null || _metadata$flags === void 0 ? void 0 : _metadata$flags.isCustomer;
  return {
    isCustomer
  };
};
exports.useCustomer = useCustomer;